/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TenantAccount } from '../../gql-types.generated';
import { RootState } from '../../store';

interface SliceState {
  tenantAccount?: TenantAccount;
  loading: boolean;
  error?: Error;
  updateLoading: boolean;
  updateError?: Error;
  updateSuccess: boolean;
}

const initialState: SliceState = {
  tenantAccount: undefined,
  loading: false,
  error: undefined,
  updateLoading: false,
  updateError: undefined,
  updateSuccess: false,
};

export const slice = createSlice({
  name: 'tenantSettings',
  initialState,
  reducers: {
    fetchTenantStart: state => {
      state.loading = true;
      state.error = undefined;
    },
    fetchTenantSuccess: (state, action: PayloadAction<TenantAccount>) => {
      state.tenantAccount = action.payload;
      state.loading = false;
      state.error = undefined;
    },
    fetchTenantError: (state, action: PayloadAction<Error>) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateTenantStart: state => {
      state.updateLoading = true;
      state.updateError = undefined;
      state.updateSuccess = false;
    },
    updateTenantSuccess: state => {
      state.updateLoading = false;
      state.updateSuccess = true;
      state.updateError = undefined;
    },
    updateTenantError: (state, action: PayloadAction<Error>) => {
      state.updateError = action.payload;
      state.updateLoading = false;
      state.updateSuccess = false;
    },
    clearUpdateStatus: state => {
      state.updateError = undefined;
      state.updateSuccess = false;
    },
    clearTenantSettings: () => initialState,
  },
});

export const selectTenantSettingsAccount = (state: RootState): TenantAccount | undefined => state.tenantSettings.tenantAccount;
export const selectTenantSettingsLoading = (state: RootState): boolean => state.tenantSettings.loading;
export const selectTenantSettingsError = (state: RootState): Error | undefined => state.tenantSettings.error;
export const selectTenantSettingsUpdateLoading = (state: RootState): boolean => state.tenantSettings.updateLoading;
export const selectTenantSettingsUpdateError = (state: RootState): Error | undefined => state.tenantSettings.updateError;
export const selectTenantSettingsUpdateSuccess = (state: RootState): boolean => state.tenantSettings.updateSuccess;

export const {
  fetchTenantStart,
  fetchTenantSuccess,
  fetchTenantError,
  updateTenantStart,
  updateTenantSuccess,
  updateTenantError,
  clearUpdateStatus,
  clearTenantSettings,
} = slice.actions;

export default slice.reducer;
